export const STRUCTURE_ROB_RESET = "STRUCTURE_ROB_RESET";
export const STRUCTURE_ROB_SET_ERROR = "STRUCTURE_ROB_SET_ERROR";
export const STRUCTURE_ROB_SET_ITEMS = "STRUCTURE_ROB_SET_ITEMS";
export const STRUCTURE_ROB_TOGGLE_LOADING = "STRUCTURE_ROB_TOGGLE_LOADING";
